/*
 *
 * BankAccounts constants
 *
 */
import { createStructuredSelector } from 'reselect';

// Constants
import successAnimationData from 'animation/success.json';
import { UPLOAD_DOCS_URL } from 'constants/url';
import { ONE_MB_VALUE } from 'utils/constants';
import { REG_KEYS } from 'constants/enums';
import { userTypeSelector } from 'containers/DashboardContainer/selectors';

// Actions
import {
  enableLoaderAction,
  getBankAccountsAction,
  getRefundRechargeAction,
  resetRefundRechargeAction,
  resetDataAction,
  verifyBankAccountAction,
  cancelNewBankAccountAction,
  enableModalLoaderAction,
  disableModalLoaderAction,
  getPayoutBankIdsAction,
  createSelfServeTicketAction,
  getBankAccountDetailsAction,
} from './actions';
import { resetTwoFactorAuthentication as resetTwoFactorAuthenticationValue } from '../Toast/actions';

// Selectors
import makeSelectBankAccounts from './selectors';
import { twoFactorAuthenticationSelector } from '../Toast/selectors';

export const BASE_ACTION_CONSTANT = 'app/BankAccounts';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const ENABLE_MODAL_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_MODAL_LOADER`;

export const DISABLE_MODAL_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_MODAL_LOADER`;

export const GET_BANK_ACCOUNTS = `${BASE_ACTION_CONSTANT}/GET_BANK_ACCOUNTS`;

export const GET_BANK_ACCOUNTS_DETAILS = `${BASE_ACTION_CONSTANT}/GET_BANK_ACCOUNTS_DETAILS`;

export const SAVE_BANK_ACCOUNTS_RESPONSE = `${BASE_ACTION_CONSTANT}/SAVE_BANK_ACCOUNTS_RESPONSE`;

export const GET_REFUND_RECHARGE = `${BASE_ACTION_CONSTANT}/GET_REFUND_RECHARGE`;

export const SAVE_REFUND_RECHARGE = `${BASE_ACTION_CONSTANT}/SAVE_REFUND_RECHARGE`;

export const RESET_REFUND_RECHARGE = `${BASE_ACTION_CONSTANT}/RESET_REFUND_RECHARGE`;

export const GET_BANK_ACCOUNTS_URL = '/pg/settlements/banks';

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const VERIFY_BANK_ACCOUNT = `${BASE_ACTION_CONSTANT}/VERIFY_BANK_ACCOUNT`;

export const CANCEL_NEW_BANK_ACCOUNT = `${BASE_ACTION_CONSTANT}/CANCEL_NEW_BANK_ACCOUNT`;

export const GET_PAYOUT_BANK_IDS = `${BASE_ACTION_CONSTANT}/GET_PAYOUT_BANK_IDS`;

export const CREATE_SELF_SERVE_TICKET = `${BASE_ACTION_CONSTANT}/CREATE_SELF_SERVE_TICKET`;

export const BANK_ACCOUNT_NAMES_ICON = {
  'KOTAK MAHINDRA': 'KOTAK',
  'HDFC BANK': 'HDFC',
  'ICICI BANK': 'ICICI',
  'STATE BANK OF INDIA': 'SBI',
  'YES BANK': 'YESBANK',
  'INDUSIND BANK': 'INDUSIND',
  'STANDARD CHARTERED BANK': 'STANDARD_CHARTERED',
  'CSB BANK': 'CSB_BANK',
  'IDBI BANK': 'IDBI',
};

export const CHECKLIST = [
  `Max file size: 20 MB`,
  'File format: .png, .jpeg, .pdf',
];

export const UPDATE_PAYOUT_OPTIONS = [
  {
    key: 'No',
    label: 'No',
    name: 'updatePayouts',
    value: 'false',
  },
  {
    key: 'Yes',
    label: 'Yes',
    name: 'updatePayouts',
    value: 'true',
  },
];
export const GET_REFUND_RECHARGE_URL = {
  url: '/pg/refunds/recharge',
  method: 'GET',
};

export const successAnimationOptions = {
  loop: false,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  animationData: successAnimationData,
};

export const initialAuthInfo = {
  timerInSeconds: 10,
  errorType: '',
};

export const fieldFormatMapper = {
  cheque_selfServe: { name: 'cheque_selfServe', url: [UPLOAD_DOCS_URL] },
};

export enum MODALS {
  EDIT_CHEQUE = 'EDIT_CHEQUE',
  CANCELLED_CHEQUE = 'CANCELLED_CHEQUE',
  CHANGE_ACCOUNT = 'CHANGE_ACCOUNT',
  UPDATE_PAYOUTS = 'UPDATE_PAYOUTS',
  REVIEW_MODAL = 'REVIEW_MODAL',
}

export enum TICKET_TYPE {
  NAME_MATCH_FAIL = 'SELF_SERVE_BAV_NAME_MATCH_FAILURE',
}
export const CANCELLED_CHEQUE_FILE_SIZE_LIMIT = ONE_MB_VALUE * 10;

export const INDIVIDUAL_ORG_TYPES = ['Proprietorship', 'Individual'];

export const REG_KEYS_TO_FETCH = [
  REG_KEYS.ACCOUNT_HOLDER,
  REG_KEYS.ACCOUNT_NUMBER,
  REG_KEYS.IFSC_CODE,
  REG_KEYS.BANK_NAME,
  REG_KEYS.ACCOUNT_HOLDER_SELF_SERVE,
  REG_KEYS.ACCOUNT_NUMBER_SELF_SERVE,
  REG_KEYS.IFSC_CODE_SELF_SERVE,
  REG_KEYS.BANK_NAME_SELF_SERVE,
  REG_KEYS.ORG_TYPE,
  REG_KEYS.OWNER_PAN_NAME,
  REG_KEYS.COMPANY_PAN_NAME,
];

export const mapStateToProps = createStructuredSelector({
  settlementBankDetails: makeSelectBankAccounts(),
  twoFactorAuthentication: twoFactorAuthenticationSelector(),
  userType: userTypeSelector(),
});

export function mapDispatchToProps(dispatch) {
  return {
    enableLoader: data => dispatch(enableLoaderAction(data)),
    getBankAccounts: data => dispatch(getBankAccountsAction(data)),
    getBankAccountDetails: data => dispatch(getBankAccountDetailsAction(data)),
    getRefundRecharge: data => dispatch(getRefundRechargeAction(data)),
    resetRefundRecharge: () => dispatch(resetRefundRechargeAction()),
    resetTwoFactorAuthentication: data =>
      dispatch(resetTwoFactorAuthenticationValue(data)),
    resetData: () => dispatch(resetDataAction()),
    verifyBankAccount: data => dispatch(verifyBankAccountAction(data)),
    cancelNewBankAccount: data => dispatch(cancelNewBankAccountAction(data)),
    getPayoutBankIds: data => dispatch(getPayoutBankIdsAction(data)),
    createSelfServeTicket: data => dispatch(createSelfServeTicketAction(data)),
    enableModalLoader: data => dispatch(enableModalLoaderAction(data)),
    disableModalLoader: data => dispatch(disableModalLoaderAction(data)),
  };
}
